export enum SeedingTypeEnum {
  FRY = 'fry',
}
